class GoogleAnalytics {
  private gtag: any;
  private trackingId: string;

  constructor(gtag: any, trackingId: string) {
    this.gtag = gtag;
    this.trackingId = trackingId;

    if (this.gtag) {
      this.gtag('config', trackingId, { send_page_view: false });
    }
  }

  public sendEvent = (
    eventName: string,
    {
      category,
      action,
      label,
      params = {},
    }: { category?: string; action?: string; label?: string; params?: Record<string, unknown> } = {},
  ): void => {
    if (!this.gtag) return;
    this.gtag('event', eventName, {
      event_category: category,
      event_action: action,
      event_label: label,
      ...params,
    });
  };

  public sendPageView = (title: string, fullUrl: string, path: string) => {
    if (!this.gtag) return;
    this.gtag('config', this.trackingId, {
      page_title: title,
      page_location: fullUrl,
      page_path: path,
    });
  };

  /**
   * Google Analytics documentation
   * https://developers.google.com/analytics/devguides/collection/gtagjs/user-timings
   */
  public sendUserTiming = (
    name: string,
    value: number,
    { category, label, params = {} }: { category?: string; label?: string; params?: Record<string, unknown> } = {},
  ): void => {
    if (!this.gtag) return;
    this.gtag('event', 'timing_complete', {
      name,
      value,
      event_category: category,
      event_label: label,
      ...params,
    });
  };
}

export default GoogleAnalytics;
